export default __webpack_public_path__ + "static/media/gmail-logo.3f396364.svg";